import React from "react";
import PropTypes from "prop-types";
import {ListItemIcon} from "@mui/material";
import {useSidebarIconStyles} from "./sidebarStyles";

const SidebarIcon = ({icon}) => {
  const {classes} = useSidebarIconStyles();
  return (
    <ListItemIcon className={classes.listItemIcon}>
      {React.cloneElement(icon, {fontSize: "small"})}
    </ListItemIcon>
  );
};

SidebarIcon.propTypes = {
  icon: PropTypes.element.isRequired,
};

export default SidebarIcon;
